module.exports = __webpack_public_path__ + "static/img/CA_graphic.7f58373.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/CA_graphic.jpg
// module id = hDlv
// module chunks = 1